import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import {
  Box, Button, Stack, TextField, Typography,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon, Save as SaveIcon } from '@mui/icons-material';

import { Container } from '@/components/common';
import { useCreateFaqPost } from '@/hooks/boards.hook';
import { successToast, errorToast } from '@/common/toast';

/**
 * FAQ 등록 페이지
 */
const FaqAddPage = () => {
  const navigate = useNavigate();
  const createFaqMutation = useCreateFaqPost();

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: {
      title: '',
      content: '',
      replyContent: '',
    },
  });

  const onSubmit = useCallback(
    async (data) => {
      try {
        await createFaqMutation.mutateAsync(data);
        successToast('FAQ가 등록되었습니다.');
        navigate('/community/faq');
      } catch (err) {
        errorToast(`FAQ 등록에 실패했습니다. - ${err.response?.data?.msg}`);
      }
    },
    [createFaqMutation, navigate]
  );

  return (
    <Container title="FAQ 등록">
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/community/faq')}
        >
          목록으로
        </Button>
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleSubmit(onSubmit)}
          disabled={!isDirty || createFaqMutation.isPending}
        >
          등록
        </Button>
      </Stack>

      <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Controller
          control={control}
          name="title"
          rules={{ required: '제목을 입력해주세요.' }}
          render={({ field }) => (
            <TextField
              {...field}
              label="제목"
              fullWidth
              required
              error={!!errors.title}
              helperText={errors.title?.message}
            />
          )}
        />
        <Controller
          control={control}
          name="content"
          rules={{ required: '질문 내용을 입력해주세요.' }}
          render={({ field }) => (
            <TextField
              {...field}
              label="질문"
              fullWidth
              multiline
              rows={6}
              required
              error={!!errors.content}
              helperText={errors.content?.message}
            />
          )}
        />
        <Controller
          control={control}
          name="replyContent"
          rules={{ required: '답변을 입력해주세요.' }}
          render={({ field }) => (
            <TextField
              {...field}
              label="답변"
              fullWidth
              multiline
              rows={6}
              required
              error={!!errors.replyContent}
              helperText={errors.replyContent?.message}
            />
          )}
        />
      </Box>
    </Container>
  );
};

export default FaqAddPage;
